import React from "react";
import "./serviceBc.css";
import Topbar from "../../components/Topbar/Topbar";
import Footer from "../../components/Footer/Footer";
import Business from "../../components/Business/Business";

const ServiceBC=()=>{
    return(
        <>
            <Topbar/>
            <div className="serviceBC-container">
                <Business/>
                <Footer/>
            </div>
        </>
    )
}

export default ServiceBC;